/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
/* eslint-disable vars-on-top */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable consistent-return */
import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';
// import custom component
import cancelIcon from '../../../../assets/images/cancel-icon.svg';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { getNDCAuditDescription, selectedAuditType } from '../store/Actions';
import { PaperComponent } from '../../../../SharedModules/utilities/utilities';

export default function ClearAuditsForNDCPopup(props) {
  // dispatch function
  const dispatch = useDispatch();
  // use Selector function
  const { auditTypeOptions } = props;
  const NDCAuditDescriptionList = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer?.ndcAuditDescriptionList
  );
  // variable deceleration
  const { open, data, disabledSaveCancelBtn } = props;
  const [state, setState] = useState({
    auditTypeCd: 'All',
    drugName: data?.drugName,
    ndc: data?.ndc,
  });

  // set Initial value
  React.useEffect(() => {
    setState({ auditTypeCd: 'All', drugName: data?.drugName, ndc: data?.ndc });
  }, [props]);
  // handing Close Popup
  const handleClose = () => {
    props.handleClose(true);
  };

  return (
    <div id="copy-contact-popup" data-testid="clear-audit-popup">
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        className="inbuilt-dialog dialogPanel custom-check dialog-600"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className="copy-contact-title"
          style={{ cursor: 'move' }}
          id="draggable-dialog-title"
        >
          <div className="float-left dialog-heading-txt">
            Clear Audits for NDC
          </div>
          <div
            className="close-popup-icon float-right"
            role="button"
            data-testid="handleClosePopup"
            onClick={handleClose}
          >
            <img alt="" src={cancelIcon} />
          </div>
          <div className="clearfix" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="form-wrapper form-wrapper-col-12">
              <div className="mui-custom-form input-md frr-invoiceAudit-width-46per">
                <TextField
                  id="NDC"
                  label="NDC"
                  fullWidth
                  disabled
                  placeholder=""
                  InputLabelProps={{ shrink: true }}
                  value={state && state.ndc}
                />
              </div>
              <div className="mui-custom-form input-md frr-invoiceAudit-width-46per">
                {state.drugName && state.drugName.length > 25 ? (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="labeler-tooltip">{state.drugName}</Tooltip>
                    }
                  >
                    <TextField
                      id="drug_name"
                      label="Drug Name"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      value={state && `${state.drugName.substring(0, 45)} ...`}
                    />
                  </OverlayTrigger>
                ) : (
                  <TextField
                    id="drug_name"
                    label="Drug Name"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{ shrink: true }}
                    value={state && state.drugName}
                  />
                )}
              </div>
            </div>
            <div className="col-6 pl-0 frr-mui-custom-form-width-96per">
              <div className="form-wrapper">
                <div className="mui-custom-form with-select ">
                  <TextField
                    label="Selected Audit Type"
                    id="auditTypeCd"
                    name="audit Type"
                    data-testid="audit-type"
                    fullWidth
                    select
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'auditTypeCd' }}
                    InputLabelProps={{ shrink: true }}
                    value={state && state?.auditTypeCd}
                    onChange={(e) => {
                      setState({ ...state, auditTypeCd: e.target.value });
                    }}
                  >
                    <MenuItem selected key="All Audit Types" value="All">
                      All Audit Types
                    </MenuItem>
                    {auditTypeOptions && auditTypeOptions.length > 0
                      ? // eslint-disable-next-line array-callback-return
                        auditTypeOptions.map((item) => {
                          if (
                            NDCAuditDescriptionList?.filter((x) => {
                              return (
                                x.auditTypeCd === item?.codeValueID?.codeValue
                              );
                            }).length > 0
                          ) {
                            return (
                              <MenuItem
                                key={item?.codeValueID?.codeValue}
                                value={item?.codeValueID?.codeValue}
                              >
                                {' '}
                                {`${item?.codeValueID?.codeValue} | ${item?.shortDescription}`}
                              </MenuItem>
                            );
                          }
                        })
                      : null}
                  </TextField>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="btn-wrapper mb-2">
            <div className="float-right hide-on-print">
              <Button
                className="btn btn-success btn-search"
                onClick={() => {
                  dispatch(selectedAuditType(state));
                }}
                data-testid="btn-ok"
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Ok
              </Button>
              <Button
                className="btn btn-cancel btn-primary"
                data-testid="btn-cancel"
                onClick={handleClose}
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>
            <div className="clearfix" />
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
